import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Projects from './pages/Projects';
import SocialMedia from './pages/SocialMedia';
import Resume from './pages/Resume';
import AboutMe from './pages/AboutMe';
import ContactMe from './pages/ContactMe';
import './App.css';
import profilePic from './assets/profile.jpg';
import backgroundVideo from './assets/background.mp4';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);

  return null;
}

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleHomeClick = (e) => {
    e.preventDefault();

    if (location.pathname === '/') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });

      window.dispatchEvent(new Event('homeReset'));
    } else {
      navigate('/');
    }
  };

  return (
    <nav className="navbar">
      <a href="/" className="profile-link" onClick={handleHomeClick}>
        <img src={profilePic} alt="Profile" className="profile-pic" />
      </a>

      <div className="nav-links">
        <Link to="/about-me">About Me</Link>
        <Link to="/resume">Resume</Link>
        <Link to="/social-media">Social Media</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/contact-me">Contact Me</Link>
      </div>
    </nav>
  );
}

function AppShell() {
  return (
    <div className="app-shell">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={backgroundVideo} type="video/mp4" />
      </video>

      <div className="video-overlay"></div>

      <ScrollToTop />
      <Navbar />

      <main className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/social-media" element={<SocialMedia />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/contact-me" element={<ContactMe />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;